// IMPORTANTE: Sentry debe inicializarse antes que todo lo demás.
import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { RouterProvider, createRouter } from '@tanstack/react-router'

import './styles/globals.css'
import './i18n/init'
import { initializePlatform } from './lib/platform'
import { routeTree } from './routeTree.gen'

initializePlatform()

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex min-h-screen items-center justify-center p-6 text-center">
          <p className="text-sm text-muted-foreground">
            Ocurrió un error inesperado. Recargá la página e intentá de nuevo.
          </p>
        </div>
      }
    >
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
